<template>
  <van-popup
    v-model:show="props.popShow"
    :round="true"
    :closeable="true"
    :close-on-click-overlay="false"
    :safe-area-inset-bottom="true"
    position="bottom"
    :style="{ height: '80%', background: '#394148' }"
    @click-close-icon="closePop"
    @click-overlay="closePop"
    class="pop"
  >
    <div class="pop-content">
      <div class="sticky">
        <slot name="title"></slot>
        <slot name="search"></slot>
        <p>请选择</p>
      </div>
      <ul>
        <li
          v-for="(item, index) in props.cacheList"
          :key="index"
          @click="select(item, index)"
          :class="{ active: index == props.selectIndex }"
        >
          <slot name="role" :item="item"></slot>
          <slot name="goods" :data="item"></slot>
        </li>
      </ul>
    </div>
    <van-loading v-show="props.popload" class="loading" :vertical="true">
      加载中...
    </van-loading>
  </van-popup>
</template>
<script setup>
import { computed, onDeactivated, reactive, ref, watch } from "vue";

const state = reactive({
  selectIndex: 0,
  nowType: "",
});

const emit = defineEmits(["closePop", "updateTypename"]);
const closePop = (e) => {
  state.selectIndex = 0;
  emit("closePop");
};

// 选择
const select = (data, index) => {
  state.selectIndex = index;
  emit("updateTypename", data);
  state.selectIndex = 0;
};

const props = defineProps({
  cacheList: {
    type: Array,
    default: [],
  },
  popShow: {
    type: Boolean,
    default: false,
  },
  selectIndex: {
    type: Number,
    default: 0,
  },
  popload: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => props.selectIndex,
  (newVal) => {
    if (newVal) {
      // console.log(newVal);
    }
  }
);
</script>
<style scoped>
.pop-content {
  position: relative;
  color: #fff;
}
.pop-content :deep(h1) {
  text-align: center;
  font-size: 32px;
}
/* 搜索框 */
:deep(.search) {
  margin: 26px 0;
  padding: 0 32px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
:deep(.search .van-cell) {
  padding: 0;
}
:deep(.search input) {
  width: 590px;
  height: 72px;
  margin-right: 32px;
  border-radius: 198px;
  border: none;
  background-color: #283138;
  padding: 24px 32px;
}
:deep(.search .van-field__body) {
  background-color: #394148;
}
.pop-content .sticky {
  position: sticky;
  top: 0;
  padding-top: 26px;
  background-color: #394148;
  z-index: 999;
  color: #fff;
  z-index: 9;
}
.pop-content .sticky p {
  color: #fff;
  font-size: 32px;
  margin-bottom: 16px;
  padding-left: 32px;
}
.pop-content ul {
  height: 100%;
  padding: 0 32px;
}
.pop-content ul li {
  padding:20px 24px;
  border-radius: 10px;
  /* border: 2px solid #f4f5f8; */
  background-color: #283138;
  margin-bottom: 12px;
  position: relative;
}
.pop-content ul li p {
  font-size: 24px;
  color: #999;
}
.pop-content ul li.active::before {
  position: absolute;
  top: -1px;
  left: -1px;
  content: "";
  width: 100%;
  height: 100%;
  border: 2px solid #00d9c3;
  border-radius: 10px;
}

:deep(loading) {
  display: flex;
  justify-content: center;
}
</style>
